import { render, staticRenderFns } from "./firstSection.vue?vue&type=template&id=10ba001a&"
import script from "./firstSection.vue?vue&type=script&lang=js&"
export * from "./firstSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports